// MobileNav.js - Grouped mobile navigation with sections
import React from 'react';
import NavLink from './NavLink';
import { getVisibleGroups } from '../../config/navigation';

const MobileNav = ({ isAuthenticated, adminLevel, onLogout, onClose, customerName }) => {
  const visibleGroups = getVisibleGroups(isAuthenticated, adminLevel);

  return (
    <nav className="md:hidden bg-gray-800 fixed top-20 left-0 right-0 z-40 max-h-[calc(100vh-5rem)] overflow-y-auto">
      <div className="p-4 space-y-4">
        {visibleGroups.map((group) => (
          <div key={group.id}>
            {/* Only show group label if there's more than just public */}
            {group.id !== 'public' && (
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 px-3">
                {group.label}
              </div>
            )}
            <div className="space-y-1">
              {group.items.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  icon={item.icon}
                  label={item.label}
                  onClick={onClose}
                  className="w-full"
                />
              ))}
            </div>
          </div>
        ))}

        {isAuthenticated && customerName && (
          <div className="px-4 py-2 text-gray-400 text-sm truncate">👤 {customerName}</div>
        )}
        {isAuthenticated && (
          <div className="pt-4 border-t border-gray-700">
            <button
              onClick={() => {
                onClose();
                onLogout();
              }}
              className="w-full text-left text-gray-300 hover:text-white hover:bg-gray-700 px-3 py-2 rounded-md transition-colors"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default MobileNav;
